class ProductAddons extends PopupBase {
  constructor() {
    super();
    this.productPopupDiv = this.querySelector(".product-addons__content");
    this.init();
  }
  init() {
    if (this.productPopupDiv) {
      this.addEventListener("click", this.onClick.bind(this));
    }
  }
  onClick() {
    const html = this.productPopupDiv;
    if (!html) return;
    html.classList.remove("hidden");
    this.initPopup(
      html,
      `<h3 class="title-popup h5 my-0 px-20 px-md-30 py-20 border-bottom">${this.dataset?.textHeader}</h3>`
    );
  }
}
customElements.define("product-addons", ProductAddons);

// Real-Time Store Hours & Open/Closed Status
function initStoreHoursStatus() {
  const badge = document.getElementById('storeStatusBadge');
  const rows = document.querySelectorAll('#businessHoursList .hours-row');
  if (!badge && rows.length === 0) return;

  // Calculate Indian Standard Time (IST, UTC+05:30)
  const now = new Date();
  const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
  const istDate = new Date(utc + (3600000 * 5.5));

  const day = istDate.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
  const hours = istDate.getHours();
  const minutes = istDate.getMinutes();
  const timeInMinutes = hours * 60 + minutes;

  // Highlight today's row in the business hours list
  rows.forEach(row => {
    const rowDay = parseInt(row.getAttribute('data-day'), 10);
    if (rowDay === day) {
      row.classList.add('is-today');
      const dayName = row.querySelector('.day-name');
      if (dayName && !dayName.querySelector('.today-chip')) {
        const todayTag = document.createElement('span');
        todayTag.className = 'today-chip';
        todayTag.textContent = 'Today';
        dayName.appendChild(todayTag);
      }
    } else {
      row.classList.remove('is-today');
    }
  });

  // Operating Hours: Monday to Saturday (1..6), 11:00 AM (660 min) to 8:00 PM (1200 min)
  // Sunday (0) is Closed
  const isOpen = (day >= 1 && day <= 6) && (timeInMinutes >= 11 * 60 && timeInMinutes < 20 * 60);

  if (badge) {
    if (isOpen) {
      badge.className = 'business-hours-badge is-open';
      badge.innerHTML = `
        <span class="status-pulse-dot"></span>
        <span class="status-label">We're currently open</span>
        <span class="status-sub">Closes at 8:00 PM</span>
      `;
    } else {
      badge.className = 'business-hours-badge is-closed';
      let nextOpen = 'Opens at 11:00 AM';
      if (day === 0) {
        nextOpen = 'Opens Monday at 11:00 AM';
      } else if (timeInMinutes < 11 * 60) {
        nextOpen = 'Opens today at 11:00 AM';
      } else {
        nextOpen = (day === 6) ? 'Opens Monday at 11:00 AM' : 'Opens tomorrow at 11:00 AM';
      }
      badge.innerHTML = `
        <span class="status-pulse-dot closed"></span>
        <span class="status-label">Currently Closed</span>
        <span class="status-sub">${nextOpen}</span>
      `;
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStoreHoursStatus);
} else {
  initStoreHoursStatus();
}
